module.exports = __webpack_public_path__ + "static/media/ipnos-conponents.c5a5b93b.png";